module.exports = __webpack_public_path__ + "img/kite.06e58978.jpg";